import React from 'react';
import { Row, Col } from 'antd';
import { Content } from './Content';
import * as S from './styles';

interface CardProps {
	title: string;
	score: number;
	description?: string;
	isFinalScore?: boolean;
}

export function Card({ title, score, description, isFinalScore = false }: Readonly<CardProps>) {
	
	const backgroundColor = isFinalScore ? '#2f54eb' : '#EAEEFD';
	const textColor = isFinalScore ? '#FFFFFF' : '#2F54EB';

	return (
		<S.Container>
			<S.Header span={24} $backgroundColor={backgroundColor}>
				<Row>
					<Col span={24}>
						<S.Label $color={textColor}>{title}</S.Label>
					</Col>
					{!!description && (
						<Col span={24}>
							<S.Description $color={textColor}>{description}</S.Description>
						</Col>
					)}
				</Row>
			</S.Header>
			<Content isCardResult={isFinalScore}>{score}</Content>
		</S.Container>
	);
}
